import Datepicker from "../../shared/components/Datepicker/Datepicker";
import { Bq1GeneralInformationM } from "../models/bq1-general-information.model";
import { formDate } from "../services/baltic-forms.utils";
import React from "react";

export function Bq1Builder(
  form: Bq1GeneralInformationM,
  updateDate: (date: Date | null, field: string) => void,
  updateForm: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void,
  readonly: boolean,
) {
  return (
    <div>
      <h2 className="mb-2 mt-[120px] text-lg font-semibold">Builder</h2>
      <br />
      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Builder name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Builder name</label>
          <input
            disabled={readonly}
            type="text"
            name="builderName"
            value={form.builderName}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Yard number */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Yard number</label>
          <input
            disabled={readonly}
            type="text"
            name="yardNumber"
            value={form.yardNumber}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Delivery date */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            <div>Delivery date</div>
          </label>
          <Datepicker
            disabled={readonly}
            selected={formDate(form.deliveryDateRecorded)}
            onChange={(date) => updateDate(date, "deliveryDateRecorded")}
          />

          <div className="mt-2 text-xs font-medium">as recorded in Form A or Form B Q1.8.3 of the IOPPC:</div>
        </div>
      </div>
    </div>
  );
}
